type Role = 'management' | 'employee' | 'hr' | string

export function getRoleBadge(role?: Role) {
  switch (role) {
    case 'management':
      return {
        className: 'bg-primary',
        icon: 'bi-diagram-3',
        label: 'Management',
      }
    case 'employee':
      return {
        className: 'bg-success',
        icon: 'bi-person-circle',
        label: 'Employee',
      }
    case 'hr':
      return {
        className: 'bg-warning text-dark',
        icon: 'bi-person-lines-fill',
        label: 'HR',
      }
    case 'finance':
      return {
        className: 'bg-success',
        icon: 'bi-cash-stack',
        label: 'Finance',
      }
    case 'manager':
      return {
        className: 'bg-dark',
        icon: 'bi-diagram-3',
        label: 'Manager',
      }
    default:
      return {
        className: '',
        icon: '',
        label: role || '',
      }
  }
}
